export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/claim.worker.9e8fcd32.worker.js");
}
